import { render, staticRenderFns } from "./TabComplete.vue?vue&type=template&id=e60b3bf4&"
import script from "./TabComplete.vue?vue&type=script&lang=js&"
export * from "./TabComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports